// import * as React from 'react'
// import './SignIn.css'
// import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../Components/Card';
// import { Icon } from '../Icons/Icon';
// import Loader from '../Components/Loader';
// import { toast, ToastContainer } from 'react-toastify';
// import { useUser } from '../DataService/UserContext';


// export const SignIn = (/*{user,userInvokeCallback}:SignInProps*/) => {
//   const [email, setEmail] = React.useState('');
//   const [password, setPassword] = React.useState('');
//   const [isLoading, setIsLoading] = React.useState(false);
//    const { signIn } = useUser();
//  const handleSubmit = async (e: React.FormEvent) => {
//   e.preventDefault();
//   setIsLoading(true);

//   const success = await signIn(email, password);

//   setIsLoading(false);

//   if (!success) {
//     toast.error("Fel e-post eller lösenord", {
//       position: "top-right",
//     });
//   }
// };

//   return (
//     <div className="signin-main">
//       <div className="signin-card-container">
//         <Card className="signin-card-main-style">
//           <CardHeader className="signin-card-heading">
//             <div className="signin-card-heading-icon-container">
//               {/* <LogIn className="h-8 w-8 text-[#E16A54]" /> */}
//               <Icon.LogIn width={40} height={40}/>
//             </div>
//             <CardTitle className="signin-card-heading-title">Logga in</CardTitle>
//             <CardDescription className="signin-card-heading-description">
//               Ange din e-post och lösenord för att komma åt ditt konto
//             </CardDescription>
//           </CardHeader>
//           <CardContent>
//             <form onSubmit={handleSubmit} className="signin-form">
//               <div className="signin-form-button-continer">
//                 <label htmlFor="email" className="signin-form-label">E-post</label>
//                 <input
//                   id="email"
//                   type="email"
//                   placeholder="Ange din e-post"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                   className="signin-form-input"
//                 />
//               </div>
              
//               <div className="signin-form-button-continer">
//                 <label htmlFor="password" className="signin-form-label">Lösenord</label>
//                 <input
//                   id="password"
//                   type="password"
//                   placeholder="Ange ditt lösenord"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   required
//                   className="signin-form-input"
//                 />
//               </div>

//               <button 
//                 type="submit" 
//                 className="signin-custom-button" 
//                 disabled={isLoading}
//               >
//                 {isLoading ? <div style={{position:'relative',display:'flex',justifyContent:'center'}}><Loader loaderSize={'SMALL'}/></div> : "Logga in"}
//               </button>
//             </form>

//             <div className="signin-forgott-link-container">
//               <a href="#" className="signing-forgott-link">
//                 Glömt ditt lösenord?
//               </a>
//             </div>
//           </CardContent>
//         </Card>
//       </div>
//       <ToastContainer />
//     </div>
//   );
// }
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { Link, useSearchParams } from "react-router-dom";
import { useUser } from "../DataService/UserContext";
import { Button } from "../Components/Button";
import FadeIn from "../Animations/FadeIn";
import Loader from "../Components/Loader";
import { Icon } from "../Icons/Icon";
import { ResetPassword } from "./ResetPassword";
import { Turnstile } from "@marsidev/react-turnstile";
import './SignIn.css'
export const SignIn = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const isE2ETesting = process.env.REACT_APP_E2E_TESTING === "1";
  const resetEmail = searchParams.get("email") ?? "";
  const resetToken = searchParams.get("token") ?? "";
  const isResetMode = searchParams.get("reset") === "1" && resetEmail && resetToken;

  const { signIn } = useUser();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!captchaToken && !isE2ETesting) {
      toast.error("Bekräfta att du inte är en robot");
      return;
    }
    setIsLoading(true);

    const success = await signIn(email, password, captchaToken ?? "e2e-test-token");

    setIsLoading(false);

    if (!success) {
      toast.error("Fel e-post eller lösenord");
    }
  };

  return (
    isResetMode ? <ResetPassword /> : (
    <div className="signin-page">
      <FadeIn className="signin-card">
        <div className="signin-header">
          <div className="signin-icon">
            <Icon.LogIn width={36} height={36} />
          </div>

          <h1 className="signin-title">Välkommen tillbaka</h1>
          <p className="signin-subtitle">
            Logga in för att fortsätta din hälsoresa
          </p>
        </div>

        <form onSubmit={handleSubmit} className="signin-form">
          <div className="signin-field">
            <label htmlFor="email">E-postadress</label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="namn@exempel.se"
            />
          </div>

          <div className="signin-field">
            <label htmlFor="password">Lösenord</label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>

          {isE2ETesting ? (
            <div className="signin-turnstile-block">
              <label>Jag är inte en robot *</label>
              <button type="button" onClick={() => setCaptchaToken("e2e-test-token")}>E2E captcha</button>
            </div>
          ) : (
            <div className="signin-turnstile-block">
              <label>Jag är inte en robot *</label>
              <Turnstile
                siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY!}
                onSuccess={(token) => setCaptchaToken(token)}
                onExpire={() => setCaptchaToken(null)}
                options={{ theme: 'light' }}
              />
            </div>
          )}

          <Button
            type="submit"
            className="signin-submit"
            disabled={isLoading || !captchaToken}
            text={
              isLoading ? (
                <Loader loaderSize="SMALL" />
              ) : (
                "Logga in"
              )
            }
          />

          <div className="signin-forgot">
            <Link to="/forgot-password">Glömt ditt lösenord?</Link>
          </div>
        </form>
      </FadeIn>

      <ToastContainer />
    </div>
    )
  );
};
